"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".content-neck {\n  padding-bottom: 3rem; }\n";
  const fileName = "ContentNeck_ContentNeck";
  const element = document.querySelector("style[data-sass-component='ContentNeck_ContentNeck']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ContentNeck = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'content-neck'
  }, props.children);
};
var _default = exports.default = ContentNeck;